import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle, Frown } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Clock className="w-10 h-10 text-brand-accent" data-id="element-128" />,
    title: 'Pérdida de Tiempo',
    description: 'Pasás horas buscando ejercicios en internet y armando clases en lugar de descansar o disfrutar tu tiempo libre.'
  }, {
    icon: <AlertTriangle className="w-10 h-10 text-brand-accent" data-id="element-129" />,
    title: 'Estrés y Desorganización',
    description: 'Llegás a la cancha sin un plan claro, improvisando sobre la marcha y sintiendo que no tenés el control del grupo.'
  }, {
    icon: <Frown className="w-10 h-10 text-brand-accent" data-id="element-130" />,
    title: 'Niños Aburridos',
    description: 'Repetís siempre los mismos ejercicios básicos y notás que los chicos pierden la motivación y la atención rápido.'
  }];
  return <section className="py-20 px-4 bg-brand-dark/50 border-y border-brand-mint/10" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <h2 className="text-4xl md:text-5xl font-display text-brand-cream mb-6 uppercase" data-id="element-134">
            ¿Te suena <span className="text-brand-accent" data-id="element-135">familiar</span> esta
            situación?
          </h2>
          <p className="text-lg text-brand-cream/80 max-w-2xl mx-auto" data-id="element-136">
            Sabemos lo difícil que es mantener la atención de los más chicos
            mientras intentás enseñarles técnica y táctica.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-137">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-card p-8 rounded-2xl border border-brand-mint/10 hover:border-brand-mint/30 transition-colors" data-id="element-138">
              <div className="bg-brand-dark w-16 h-16 rounded-xl flex items-center justify-center mb-6 shadow-inner" data-id="element-139">
                {problem.icon}
              </div>
              <h3 className="text-2xl font-display text-brand-cream mb-4 tracking-wide" data-id="element-140">
                {problem.title}
              </h3>
              <p className="text-brand-cream/70 leading-relaxed" data-id="element-141">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}